import { UserRole } from '@/types/users';

export const canViewerAccessLeaderInsights = (
  role: UserRole | null,
  managesLeaders: boolean | undefined
): boolean => {
  if (!role) {
    return false;
  }

  if (role === 'admin' || role === 'people_experience') {
    return true;
  }

  if (role === 'user') {
    return managesLeaders === true;
  }

  return false;
};
